import { getTokenGlobick, globickMMB } from "services/util/globick-service";
import { useEffect, useState } from "react";
import useSession from "hooks/useSession";
import { LoginModal } from "../LoginModal/LoginModal";
import { useLocation, useParams } from "react-router-dom";

export const RecoglobickActivitiesMmb = () => {
  const { tokenGlobick, userConnected, logged, setTokenGlobick, setLogged } =useSession();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [openMissing, setOpenMissing] = useState(false);

  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {

    if (logged) {
      const missingMandatoryInfo = userConnected?.missingMandatoryInfo;
      // force mandatory info
      if (missingMandatoryInfo) {
        setOpenMissing(true);
        return;
      } else {
        //Metodo para cargar globick
        setLogged(true);
        setShowLoginModal(false);
        getTokenGlobick(
          window.sessionStorage["raas-trip-mock"],
          (response: any) => {
            setTokenGlobick(response);
           const status = query.get('id') as any;
            globickMMB(response, status,'es-ES');
          },
          (e: any) => console.log("error", e)
        );
      }
    } else {
      setShowLoginModal(true);
    }
  }, [logged]);

  return (
    <>
      {showLoginModal ? (
        <LoginModal openMissing={openMissing} openModal={showLoginModal} 			urlNavigate="/activity-management" />
      ) : (
        <div className="activities-container">
          <div id="recoglobick-activities-mmb" />
        </div>
      )}
    </>
  );
};
